module.exports = __webpack_public_path__ + "img/slider-home-3.86f5fdb2.png";